import { REGISTER, CLEAR_REGISTER_ERROR } from './constants/actionTypes'
import fusionAPI from './api/fusionApi'

export const registerUser = (payload) => ({
    type: REGISTER.default,
    payload,
})

export const clearregisterUser = () => ({
    type: CLEAR_REGISTER_ERROR.default,
})

export const clearregisterUserBoundActionCreator = () => (dispatch) => {
    dispatch(clearregisterUser())
}

export const registerUserBoundActionCreator =
    (registrationCredentials, cb, referrer) => async (dispatch) => {
        const data = referrer ? { referrer } : {}
        const payload = fusionAPI.register('', {
            user: { ...registrationCredentials, data },
            registration: {
                applicationId: `${process.env.REACT_APP_FUSION_APP_ID}`,
            },
        })

        dispatch(registerUser(payload))
            .then(({ value }) => {
                if (value?.statusCode === 200) {
                    const registeredUserEmail =
                        value?.response?.user?.email ?? ''
                    cb(registeredUserEmail)
                }
            })
            .catch((error) => console.log({ error }))
    }

export default registerUserBoundActionCreator
